<template>
	<div class="radio-picker">
		<label
			v-for="(option, index) in options"
			:key="'radio-option-' + index"
			:class="['radio-option', { checked: checked === index, dark, disabled: option.disabled }]"
		>
			<input
				v-model="checked"
				type="radio"
				:id="option.label"
				:name="option.label"
				:value="index"
				:checked="checked"
				:disabled="option.disabled"
			/>
			<span class="custom-radio" />
			{{ option.label }}
			<span
				v-if="option.rightText"
				class="right-text"
			>
				{{ option.rightText }}
			</span>
			<img
				v-if="option.image"
				class="icon"
				:src="convertToCdnUrl(option.image.src)"
				:alt="option.image.alt"
				lazy
			>
		</label>
	</div>
</template>

<script>
import { convertToCdnUrl } from 'utils';

export default {
	props: {
		/**
		 * Format of array objects
		 * {
		 * 		label: String, (required)
		 * 		rightText: String, (not required)
		 * 		disabled: Boolean, (not required)
		 * 		image: { (not required)
		 * 				src: whole source without cdn converted, (required for image)
		 * 				alt: String, (required for image)
		 * 		}
		 * }
		 */
		options: {
			type: Array,
			default: () => [],
			required: true,
		},
		/* Based on the array index of options */
		value: {
			type: Number,
			default: 0,
			required: true,
		},
		dark: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	data () {
		return {
			convertToCdnUrl,
			checked: 0,
		};
	},
	mounted () {
		this.checked = this.value;
	},
	watch: {
		checked(to, frm) {
			if (this.options[to]?.disabled) {
				this.checked = frm;
				return;
			}

			if ((to || to === 0) && to !== this.value) {
				this.$emit('input', to);
				this.$emit('change', to);
			}
		},
		value () {
			this.checked = this.value;
		},
	}
};
</script>
